
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.body.classList.add('loaded');

  var nav=document.getElementById('nav'), bar=document.getElementById('bar'),
      heroMedia=document.getElementById('heroMedia'), spk=document.getElementById('spkImg'),
      endMedia=document.getElementById('endMedia'),
      hscroll=document.querySelector('.hscroll'), track=document.getElementById('track'),
      steps=[].slice.call(document.querySelectorAll('.step')),
      about=document.getElementById('about'),
      clinic=document.getElementById('clinic'),
      clinB=document.getElementById('clinB'),
      wA=document.getElementById('wA'), wB=document.getElementById('wB');

  /* reveal on scroll */
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
  },{threshold:.16,rootMargin:'0px 0px -8% 0px'});
  document.querySelectorAll('.rv,.imgbox').forEach(function(el){ io.observe(el); });

  /* three level frames, bound to the three level rows.
     scrolling past a frame lights its level; opening a level lights its frame. */
  var lvlImgs=[].slice.call(document.querySelectorAll('.approach-right .lvl')),
      lvlNow=-1;
  /* keep the whole open level reachable: if the sticky column is taller than the
     viewport, pin it so its bottom clears the fold instead of hanging off it. */
  var aLeft=document.querySelector('.approach-left');
  function setStick(){
    if(!aLeft) return;
    if(window.innerWidth<=900){ aLeft.style.removeProperty('--stick-top'); return; }
    var base=Math.max(90,Math.min(150,window.innerHeight*0.16));
    var fit=window.innerHeight-aLeft.offsetHeight-40;
    aLeft.style.setProperty('--stick-top', Math.min(base,fit)+'px');
  }
  /* mobile menu */
  var navToggle=document.getElementById('navToggle'), navPanel=document.getElementById('navPanel');
  function closeNav(){
    document.body.classList.remove('nav-open');
    if(navToggle) navToggle.setAttribute('aria-expanded','false');
  }
  if(navToggle && navPanel){
    navToggle.addEventListener('click',function(){
      var open=document.body.classList.toggle('nav-open');
      navToggle.setAttribute('aria-expanded',open?'true':'false');
      if(open){ var f=navPanel.querySelector('a'); if(f) f.focus(); }
    });
    navPanel.addEventListener('click',function(e){ if(e.target.closest('a')) closeNav(); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'||e.keyCode===27) closeNav(); });
    window.addEventListener('resize',function(){ if(window.innerWidth>900) closeNav(); });
  }

  window.addEventListener('resize',setStick);
  window.addEventListener('load',setStick);
  /* the column's height only settles once the open/close transition finishes,
     so recompute the pin point then rather than trusting a stale measurement */
  document.querySelectorAll('.step-detail').forEach(function(d){
    d.addEventListener('transitionend',setStick);
  });

  function setLevel(i,openRow){
    if(i===lvlNow || i<0) return;
    lvlNow=i;
    lvlImgs.forEach(function(el,k){ el.classList.toggle('is-on', k===i); });
    steps.forEach(function(st,k){
      var on = (k===i);
      st.classList.toggle('lit', on);
      if(openRow!==false){
        st.classList.toggle('active', on);
        var hd=st.querySelector('.step-head');
        if(hd) hd.setAttribute('aria-expanded', on?'true':'false');
      }
    });
    setTimeout(setStick,540);
  }
  setStick();
  setLevel(0);

  /* level accordion: click to open, Level 1 open by default */
  steps.forEach(function(st,idx){
    var head=st.querySelector('.step-head');
    if(!head) return;
    head.addEventListener('click',function(){
      var isOpen=st.classList.contains('active');
      steps.forEach(function(o){
        o.classList.remove('active');
        var h2=o.querySelector('.step-head'); if(h2) h2.setAttribute('aria-expanded','false');
      });
      if(!isOpen){ st.classList.add('active'); head.setAttribute('aria-expanded','true'); }
      setLevel(idx,false);
    });
  });

  function clamp(v,a,b){ return Math.max(a,Math.min(b,v)); }

  var ticking=false;
  function frame(){
    ticking=false;
    var y=window.pageYOffset, vh=window.innerHeight;

    nav.classList.toggle('scrolled', y>60);

    if(lvlImgs.length && window.innerWidth>900){
      /* even thirds of the block's scroll, so each level gets the same run
         instead of being driven by however tall its photo happens to be */
      var ar=about.getBoundingClientRect();
      if(ar.top<vh && ar.bottom>0){
        var span=ar.height-vh;
        var prog=span>0 ? clamp((-ar.top)/span,0,0.999) : 0;
        setLevel(Math.floor(prog*3));
      }
    }

    var doc=document.documentElement.scrollHeight-vh;
    bar.style.width=(doc>0? (y/doc)*100 : 0)+'%';

    if(reduce) return;

    /* hero parallax + fade */
    if(y<vh*1.2){
      heroMedia.style.transform='translate3d(0,'+(y*0.32)+'px,0) scale('+(1+y/vh*0.06)+')';
    }

    /* level rail: the text column is sticky, so the rows do not travel past a fixed
       read line. drive the highlight from progress through the section instead. */
    if(steps.length && about){
      var ab=about.getBoundingClientRect();
      if(ab.bottom>vh*0.25 && ab.top<vh*0.75){
        var span=ab.height-vh;
        var prog=span>0 ? (-ab.top)/span : 0;
        prog=Math.max(0,Math.min(0.999,prog));
        var idx=Math.floor(prog*steps.length);
        steps.forEach(function(st,i){ st.classList.toggle('lit', i===idx); });
      } else {
        steps.forEach(function(st){ st.classList.remove('lit'); });
      }
    }

    /* speaker image counter-parallax */
    if(spk){
      var r=spk.parentNode.getBoundingClientRect();
      if(r.bottom>0 && r.top<vh){
        var p=(vh-r.top)/(vh+r.height);
        spk.style.transform='translate3d(0,'+((p-0.5)*-46)+'px,0)';
      }
    }

    /* clinician: wipe the table frame into the field frame across the section */
    if(clinB && clinic){
      var cb=clinic.getBoundingClientRect();
      if(cb.bottom>0 && cb.top<vh){
        /* the grid is pinned for the section's height, so key the wipe to how far
           through the pin we are, not to a generic viewport traverse. otherwise the
           swap fires before the copy has even settled. */
        var cspan=cb.height-vh;
        var t=cspan>0 ? Math.max(0,Math.min(1,(-cb.top)/cspan)) : 0;
        t=Math.max(0,Math.min(1,(t-0.20)/0.50));
        var e=t<0.5 ? 2*t*t : 1-Math.pow(-2*t+2,2)/2;
        clinB.style.clipPath='inset(0 '+((1-e)*100).toFixed(2)+'% 0 0)';
        var past=e>0.5;
        if(wA) wA.classList.toggle('on',!past);
        if(wB) wB.classList.toggle('on',past);
        if(clinB.play){
          if(e>0.06 && !reduce){ if(clinB.paused) clinB.play().catch(function(){}); }
          else if(!clinB.paused){ clinB.pause(); }
        }
      } else if(clinB.pause && !clinB.paused){ clinB.pause(); }
    }

    /* end cta drift */
    if(endMedia){
      var r2=endMedia.parentNode.getBoundingClientRect();
      if(r2.bottom>0 && r2.top<vh){
        var p2=(vh-r2.top)/(vh+r2.height);
        endMedia.style.transform='translate3d(0,'+((p2-0.5)*-70)+'px,0)';
      }
    }

    /* horizontal pinned scroll */
    if(hscroll && track && window.innerWidth>900){
      var hr=hscroll.getBoundingClientRect();
      var total=hscroll.offsetHeight-vh;
      if(total>0){
        var prog=clamp((-hr.top)/total,0,1);
        var dist=track.scrollWidth-window.innerWidth+40;
        track.style.transform='translate3d('+(-prog*Math.max(dist,0))+'px,0,0)';
      }
    }
  }
  function onScroll(){ if(!ticking){ ticking=true; requestAnimationFrame(frame); } }
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll);
  frame();
})();
